import type { AssetGroup } from '@/types/asset';

/**
 * Detects whether an `AssetGroup` is a LUT asset. LUTs live on the
 * `motion` discriminant of `AssetGroup` and only differ by an optional
 * `is_lut` flag, so this predicate is the canonical way to distinguish
 * them. Non-motion assets always return false.
 */
export const assetGroupIsLut = ({ asset }: { asset: AssetGroup }) => {
  const isMotionAsset = asset.type === 'motion';

  if (!isMotionAsset) {
    return false;
  }

  if (asset.data && 'is_lut' in asset.data) {
    return !!asset.data.is_lut;
  }

  return false;
};
